

// Template Dashboard 2 MUI Base Styles
import colors from "assets/theme-dark/base/colors";

const { transparent, light, white } = colors;

const iconButton = {
  styleOverrides: {
    root: {
      color: white.main,
      "&:hover": {
        backgroundColor: transparent.main,
        color: light.main,
      },
      "&:disabled": {

        color: light.main,
      },
    },
  },
};

export default iconButton;
